module.exports = __webpack_public_path__ + "static/media/SeguroTuristaNegro.144ec129.png";